import React from 'react';
import { CHANNELS } from '../constants/channels';

export function getRandomColor() {
    let letters = '012345'.split('');
    let color = '#';
    color += letters[Math.round(Math.random() * 5)];
    letters = '0123456789ABCDEF'.split('');
    for (let i = 0; i < 5; i++) {
        color += letters[Math.round(Math.random() * 15)];
    }
    return color;
}

export function getMaximallyDifferentRandomColor(colorIndex, totalColors) {
    if(totalColors < 1) totalColors = 1;
    return hslToHex(colorIndex * (360 / totalColors) % 360, 0.5, 0.6);
}

export function hslToHex(h, s, l) {
    h /= 360;
    let r, g, b;
    if (s === 0) {
        r = g = b = l; // achromatic
    } else {
        const hue2rgb = (p, q, t) => {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    const toHex = x => {
        const hex = Math.round(x * 255).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export class CustomizedDot extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        let channel = this.props.dataKey.split("-")[0].toUpperCase();
        if (channel === CHANNELS.MFN) {
            return (
                <svg>
                    <circle cx={this.props.cx} cy={this.props.cy} r="5" fill={this.props.stroke}/>
                </svg>)
        } else if (channel === CHANNELS.RETAIL) {
            return (
                <svg>
                    <rect x={this.props.cx - 5} y={this.props.cy - 5} width="10" height="10" fill={this.props.stroke}/>
                </svg>
            )
        } else if (channel === CHANNELS.FBA) {
            let cx = this.props.cx;
            let cy = this.props.cy;
            let xr = 4;
            let yr = 7;
            let diamondPath = [[cx - xr, cy].join(","), [cx, cy + yr].join(","), [cx + xr, cy].join(","), [cx, cy - yr].join(",")].join(" ");
            return (
                <svg>
                    <polygon points={diamondPath} fill={this.props.stroke}/>
                </svg>
            )
        } else {
            return "";
        }
    }
}




// WEBPACK FOOTER //
// ./src/utils/graph-utils.jsx